import { Design, ObjectClass } from '@app/types';
import { ModuleUsedInfo, getModulesUsage } from './get-modules-usage';

export type NodeUsedInfo = ModuleUsedInfo & {
  nodeName: string;
  nodeId: string;
  parentNodeId: string | undefined;
};

export function getDsids(serialized: Design): NodeUsedInfo[] {
  const modulesUsage = getModulesUsage(serialized);

  return serialized.components.modules.map((mod) => {
    const moduleUsage = modulesUsage[mod.id];
    if (!moduleUsage) {
      throw new Error(`Unable to get useage for module '${mod.name}' (${mod.id}).`);
    }

    return mod.versions[1].flow.nodes.filter((node) => {
      return node._class === ObjectClass.input;
    }).map((node): NodeUsedInfo => {
      return {
        ...moduleUsage,
        nodeName: node.name,
        nodeId: node.id,
        parentNodeId: node.props.parentComponentID
      };
    });
  }).flat();
}
